import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import TriggerSettings from 'bundles/internal-enterprise/components/trigger/TriggerSettings';
import Button from 'bundles/internal-ui/components/buttons/Button';
import Card from 'bundles/internal-ui/components/cards/Card';
import TextBox from 'bundles/internal-ui/components/forms/TextBox';

import 'css!../__styles__/EnterpriseToolsHome';

class EnterpriseTriggersHome extends React.Component<
  {},
  {
    textBox: string;
    query: string;
    errorMessage: string;
  }
> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof EnterpriseTriggersHome.contextTypes>;

  constructor(props: $TSFixMe) {
    super(props);
    this.state = {
      textBox: '',
      query: '',
      errorMessage: '',
    };
  }

  handleUpdateText = (e: $TSFixMe) => {
    this.setState({
      textBox: e.target.value,
    });
  };

  getUserInformation = () => {
    const { textBox } = this.state;
    this.setState(() => ({
      query: textBox,
    }));
  };

  render() {
    const { errorMessage, query } = this.state;
    const isButtonDisabled = !this.state.textBox || this.state.textBox.length < 1;
    return (
      <div className="rc-EnterpriseTriggersHome">
        <Card flexibleHeight>
          <h1>Enterprise Unenrollment Trigger</h1>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.getUserInformation();
            }}
          >
            <TextBox placeholder="Program Id" onUpdateField={this.handleUpdateText} currentValue={this.state.textBox} />
            <div>
              <Button
                className="inline"
                onClick={this.getUserInformation}
                text="Search"
                type="submit"
                btnStyle={isButtonDisabled ? 'disabled' : 'info'}
                disabled={isButtonDisabled}
              />
              {errorMessage && <span className="inline error-message">{errorMessage}</span>}
            </div>
          </form>
        </Card>
        {query && query.length > 0 && <TriggerSettings programId={query} />}
      </div>
    );
  }
}

export default EnterpriseTriggersHome;
